module.exports = __webpack_public_path__ + "static/media/chart-dot-blue.f771b6af.svg";